import React, { ReactNode } from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: ReactNode;
  intro?: ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-357" data-mp="3k06srj15o7sz">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.16em] sm:text-sm ${dark ? 'text-sky' : 'text-accent'}`} data-id="element-358" data-mp="3k29l49ps6d0v">{eyebrow}</p>}
      <h2 className={`mt-3 text-balance font-display text-[30px] font-bold leading-[1.12] sm:text-4xl lg:text-[44px] ${dark ? 'text-white' : 'text-ink'}`} data-id="element-359" data-mp="gjzqngye2imb">
        {title}
      </h2>
      {intro && <div className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? 'text-white/75' : 'text-muted'}`} data-id="element-360" data-mp="6s2ea6vn9km0">{intro}</div>}
    </div>;
}